import React from 'react';
import { observer } from 'mobx-react';
import { useStores } from '../../hooks/use-stores';
import Managers from '../../components/company/managers';
import { extractErrorMessage } from '../../utils/helpers';

function CompanyManagers({ company }) {
    const { partnerStore, authStore, commonStore } = useStores();

    const { addingManager, addManagerError } = partnerStore;

    const addManager = async (form) => {
        return await partnerStore.addManager(company.company_id, form.values());
    };

    const removeManager = async (companyId, email) => {
        await partnerStore.removeManager(companyId, email);
    };

    const sendLoginInfo = async (managerEmail, companyId) => {
        try {
            await authStore.signin(
                managerEmail,
                companyId,
                null,
                null,
                '/',
                'login-info'
            );
        } catch (error) {
            commonStore.error(extractErrorMessage(error));
        }
    };

    return (
        <Managers
            company={company}
            addingManager={addingManager}
            addManagerError={addManagerError}
            addManager={addManager}
            removeManager={removeManager}
            sendLoginInfo={sendLoginInfo}
        />
    );
}

export default observer(CompanyManagers);
